import React from 'react'
import { fmt, kindClass, actionLabel } from './format'

const CAP_LABELS = [
    ['Team', 'Team'],
    ['Sites', 'Sites'],
    ['Schedule', 'Schedules'],
    ['Tickets', 'Tickets'],
    ['Workflow', 'Workflow'],
    ['Digests', 'Digests'],
    ['Invoices', 'Invoices'],
    ['Scoring', 'Scores'],
    ['HighVolume', 'High volume'],
]

// "Dashboard auto-detected as ... from N users ..." - explains why blocks are on or off.
export const ProfileStrip = ({ data, unit, canEdit, onSettings }) => {
    const p = data?.Profile
    const c = p?.Counts
    if (!p || !c) return null
    const caps = data?.Capabilities || {}
    const on = CAP_LABELS.filter(([k]) => Boolean(caps[k])).map(([, l]) => l)
    return (
        <div className="profile">
            <span>
                {p.IsOverridden ? (
                    <>
                        Dashboard type set in Settings: <b>{p.TypeName || p.Type}</b> · company data:{' '}
                    </>
                ) : (
                    <>
                        Dashboard type: <b>Auto-detect</b>, currently <b>{p.TypeName || p.Type}</b> from{' '}
                    </>
                )}
                <b>{fmt(c.Users)}</b> user{c.Users === 1 ? '' : 's'} · <b>{fmt(c.Customers)}</b> customer
                {c.Customers === 1 ? '' : 's'} · <b>{fmt(c.TemplatesUsed)}</b> templates · <b>{fmt(c.Audits90)}</b>{' '}
                {unit(c.Audits90)} in 90 days
                {on.length ? ` · showing: ${on.join(', ')}` : ''}
            </span>
            {canEdit && (
                <button type="button" className="hd-link" onClick={onSettings}>
                    Change in Settings
                </button>
            )}
        </div>
    )
}

export const InboxGroups = ({ groups, nav, showAll = true }) => (
    <div style={{ padding: '6px 0 8px' }}>
        {groups.map(g => {
            const k = kindClass(g.Kind)
            const allPath = showAll ? nav.groupListPath(g) : null
            return (
                <div className="grp" key={g.Key}>
                    <div className="gh">
                        {g.Title}
                        <span className={`n ${k}`}>{fmt(g.Count)}</span>
                        {allPath && g.Count > (g.Items || []).length && (
                            <button type="button" className="hd-link" onClick={() => nav.navigate(allPath)}>
                                All
                            </button>
                        )}
                    </div>
                    {(g.Items || []).slice(0, 5).map((i, idx) => (
                        <div className={`it ${k}`} key={`${g.Key}-${i.Id || idx}-${i.AuditId || ''}`}>
                            <div>
                                <div className="t">{i.Title}</div>
                                {i.Subtitle && <div className="s">{i.Subtitle}</div>}
                            </div>
                            <button type="button" className="hd-btn sm o" onClick={() => nav.openInboxItem(g, i)}>
                                {actionLabel(i.Action)}
                            </button>
                        </div>
                    ))}
                </div>
            )
        })}
    </div>
)

export const InboxCard = ({ groups, nav, title = 'Priority inbox', sticky = true, canEdit, onSettings }) => {
    const list = (groups || []).filter(g => g && g.Count > 0)
    const total = list.reduce((a, g) => a + Number(g.Count || 0), 0)
    return (
        <aside className={`card${sticky ? ' inbox' : ''}`}>
            <div className="card-h">
                <div>
                    <h3>{title}</h3>
                    <div className="sub">
                        {total ? `${fmt(total)} item${total === 1 ? '' : 's'} need a decision` : 'Nothing needs you right now'}
                    </div>
                </div>
                {canEdit && (
                    <button type="button" className="hd-link" onClick={onSettings}>
                        Settings
                    </button>
                )}
            </div>
            {list.length ? (
                <InboxGroups groups={list} nav={nav} />
            ) : (
                <div className="card-b empty">All clear.</div>
            )}
        </aside>
    )
}

export const Card = ({ title, sub, action, onAction, children }) => (
    <div className="card">
        <div className="card-h">
            <div>
                <h3>{title}</h3>
                {sub && <div className="sub">{sub}</div>}
            </div>
            {action && (
                <button type="button" className="hd-link" onClick={onAction}>
                    {action}
                </button>
            )}
        </div>
        <div className="card-b">{children}</div>
    </div>
)
